import { withInstall } from "../utils/index.mjs";
import _Tab from "./Tab.mjs";
const Tab = withInstall(_Tab);
var stdin_default = Tab;
import { tabProps } from "./Tab.mjs";
import { useTabStatus, useAllTabStatus } from "../composables/use-tab-status.mjs";
export {
  Tab,
  stdin_default as default,
  tabProps,
  useAllTabStatus,
  useTabStatus
};
